import { AppDispatch } from 'store';
import { transitDataSlice } from 'store/reducers/transitData';
import { TransitDataReducer } from 'types/mainPage';

export const setTransitionsData =
  (data: TransitDataReducer) => (dispatch: AppDispatch) => {
    dispatch(transitDataSlice.actions.setTransitData(data));
  };

export const resetTransitionData =
  (from: string) => (dispatch: AppDispatch) => {
    dispatch(transitDataSlice.actions.resetTransitionData(from));
  };

export const setNeedShowAteAction =
  (show: boolean) => (dispatch: AppDispatch) => {
    dispatch(transitDataSlice.actions.setNeedShowAte(show));
  };
